import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  inject
} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuestionBase } from '../classes/question-base';
import { DynamicFormQuestionControlService } from '../question-control.service';
import { DynamicFormQuestionParserService } from '../question-parser.service';

@Component({
  selector: 'bepatient-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  providers: [DynamicFormQuestionControlService],
  standalone: false
})
export class DynamicFormComponent implements OnChanges {
  private fb = inject(UntypedFormBuilder);
  private qcs = inject(DynamicFormQuestionControlService);
  private parser = inject(DynamicFormQuestionParserService);

  @Input() questions: QuestionBase<any>[] = [];
  @Input() invalidFields;
  @Input() defaultValue;
  @Input() expectedOutputFormat: string;

  @Output() valueChange = new EventEmitter<any>();
  @Output() validChange = new EventEmitter<boolean>();

  subscription: Subscription;
  form: UntypedFormGroup = this.fb.group({});

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes.invalidFields &&
      changes.invalidFields.currentValue
    ) {
      this.questions = this.qcs.addInvalid(
        changes.invalidFields.currentValue,
        this.questions
      );
    }
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!!this.questions) {
      this.form = this.qcs.createFormGroup(this.questions);
      const parsedValue = this.qcs.setFormValue(
        this.defaultValue,
        this.questions
      );
      this.subscription = this.form.valueChanges
        .pipe(
          map(values => {
            this.qcs.checkConditionnals(values, this.questions);
            switch (this.expectedOutputFormat) {
              case 'jsonObjectForMobiFilter':
                return this.parser.parseFilterForm(values);

              default:
                this.parser.formatDataToPostToMobi(values, this.questions);
                return values;
            }
          })
        )
        .subscribe(value => {
          this.valueChange.emit(value);
          this.validChange.emit(this.form.valid);
        });
      this.form.patchValue(parsedValue);
    }
  }
}
